<po-page-list #poPageListComponent
  p-title="Criação Romaneio - Lista"
  [p-breadcrumb]="breadcrumb"
  [p-filter]="filterSettings"
>
  <div class="po-row">
    <po-button class="po-md-3" p-kind="secondary" p-label="Novo Romaneio" (p-click)="openModalNovoRomaneio()" > </po-button>
  </div>
  <po-table class="po-sm-12 po-md-12 po-lg-12"
    [p-height]="600"
    [p-hide-select-all]="true"
    [p-sort]="true"
    [p-striped]="true"
    [p-columns]="tabelaPrincipalColunas"
    [p-items]="tabelaPrincipalItens"
    [p-actions]="tabelaPrincipalAction"
    [p-actions-right]="false"
    p-spacing="small"
    [p-filter-type]="poSearchFilterMode"
    p-hide-table-search="false"
    p-auto-collapse="true"
  ></po-table>

</po-page-list>

<po-modal #advancedFilterModal p-title="Filtros" [p-primary-action]="advancedFilterPrimaryAction">
  <form #f="ngForm">
    <po-datepicker
      class="po-md-6"
      name="DZ00DATA_DE"
      [(ngModel)]="tabelaPrincipalFiltro.dados.DZ00DATA_DE"
      p-format="dd/mm/yyyy"
      [p-iso-format]="formatExtended"
      p-label="Data de:"
    ></po-datepicker>
    <po-datepicker
      class="po-md-3"
      name="DZ00DATA_ATE"
      [(ngModel)]="tabelaPrincipalFiltro.dados.DZ00DATA_ATE"
      p-format="dd/mm/yyyy"
      [p-iso-format]="formatExtended"
      p-label="Data até:"
    ></po-datepicker>
    <po-input
      class="po-md-6"
      name="CZ00COD"
      [(ngModel)]="tabelaPrincipalFiltro.dados.CZ00COD"
      p-label="Código Romaneio"
      [p-maxlength]="6"
    ></po-input>
    <po-input
      class="po-md-6"
      name="CZ00ORIGEM"
      [(ngModel)]="tabelaPrincipalFiltro.dados.CZ00ORIGEM"
      p-label="Origem"
      [p-maxlength]="2"
    ></po-input>
    <po-select
      class="po-md-6"
      name="CZ00STATUS"
      [(ngModel)]="tabelaPrincipalFiltro.dados.CZ00STATUS"
      p-label="Status"
      [p-options]="varStatus"
      [p-required]="true"
    ></po-select>
  </form>
</po-modal>

<po-modal #criarRomaneioModal p-title="Novo Romaneio" [p-primary-action]="criarRomaneioAction">
  <form #f="ngForm">
    <po-select
      class="po-md-6"
      name="CZ00DESTIN"
      [(ngModel)]="novoCadastroRomaneio.CZ00DESTIN"
      p-label="Destino (*)"
      [p-options]="varOrigemDestino"
      (p-change)="alteraDestino()"
      [p-required]="true"
    ></po-select>
    <po-lookup
      class="po-md-6"
      p-label="Veículo"
      name="CZ00PLACA"
      [(ngModel)]="novoCadastroRomaneio.CZ00PLACA"
      p-field-value="CDA3PLACA"
      p-field-label="CDA3DESC"
      [p-columns]="veiculoColumnsFilters"
      [p-field-format]="veiculoFieldFormaterFilters"
      [p-filter-service]="veiculoLookupService"
      [p-advanced-filters]="veiculoAdvancedFilters"
      [p-literals]="{ modalTitle: 'Veículo' }"
      [p-required]="true"
    ></po-lookup>
  </form>
</po-modal>
